export const APPLY_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdGtXUG3xorvWtXjDGyb6xG4XriyDLKZiiehlnTeIdEMNc97A/viewform";

export const PRELIMS_CRASH_URL = "https://forms.gle/gFawrm9DEbRnptKt8";

// Example galleries per program (attached by user, hosted on Emergent CDN)
export const PROGRAM_EXAMPLES = {
  foundation: [
    {
      src: "https://customer-assets.emergentagent.com/job_upsc-mentorship-hub/artifacts/qormth5q_program%201%20pdf%20examples%20.webp",
      caption: "4-week study plans for Polity, History, Economy & Environment — shared with every enrolled aspirant.",
    },
  ],
  prelims: [
    {
      src: "https://customer-assets.emergentagent.com/job_upsc-mentorship-hub/artifacts/rsfsxux3_program%202%20details%20Crash%20Course.webp",
      caption: "Crash course curriculum — 22 sessions across Polity, Economy, History, Geography, Environment.",
    },
  ],
  answerWriting: [
    {
      src: "https://customer-assets.emergentagent.com/job_upsc-mentorship-hub/artifacts/oprfh7zt_copy%20evaluation%20example%201.webp",
      caption: "Evaluated Mains copy — sidehead marking, structure feedback, value-addition suggestions in red.",
    },
    {
      src: "https://customer-assets.emergentagent.com/job_upsc-mentorship-hub/artifacts/tny0sg1g_copy%20evaluation%20example%202.webp",
      caption: "Introduction/conclusion rewrites, mnemonic prompts and mind-map recommendations — every answer, every week.",
    },
  ],
};

// Real WhatsApp testimony screenshot (composite)
export const TESTIMONIES_IMAGE =
  "https://customer-assets.emergentagent.com/job_upsc-mentorship-hub/artifacts/g6y9123g_Student%20testimoies.webp";

export const CONTACT = {
  phone: "9595975562",
  phoneIntl: "+919595975562",
  email: "Navsankalpias@gmail.com",
  whatsapp: "https://wa.me/919595975562",
  telegram: "https://t.me/+919595975562",
  instagram: "https://instagram.com/NavSankalp.ias",
  youtube: "https://youtube.com/@NavSankalpIAS",
  threads: "https://www.threads.net/@navsankalp.ias",
};

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_4ad68f62-520d-4776-aa8b-293b0b1912e2/artifacts/gy7ly73o_NAVSANKALPIAS.PNG",
  portrait:
    "https://customer-assets.emergentagent.com/job_4ad68f62-520d-4776-aa8b-293b0b1912e2/artifacts/11se7mgj_21B56392-7B0F-41C2-8E12-D4DD523FC6A1%202.PNG",
  poster:
    "https://customer-assets.emergentagent.com/job_4ad68f62-520d-4776-aa8b-293b0b1912e2/artifacts/uf3fw5te_IMG_6811.webp",
};

export const PROGRAM_FEATURES = [
  {
    n: "01",
    title: "Weekly & Monthly Targets",
    desc: "Structured deadlines that convert vast UPSC syllabus into measurable, achievable milestones.",
  },
  {
    n: "02",
    title: "Personalised Roadmap",
    desc: "A study plan crafted around your background, working hours, strengths and weak subjects.",
  },
  {
    n: "03",
    title: "Mentor-Led Strategy",
    desc: "Direct guidance from Himanshu Bhansali Sir on Prelims, Mains and Optional preparation.",
  },
  {
    n: "04",
    title: "Doubt-Clearing & Review",
    desc: "One-to-one review sessions to eliminate confusion and correct course early.",
  },
  {
    n: "05",
    title: "Current Affairs Integration",
    desc: "Curated daily and monthly current affairs mapped precisely to the UPSC syllabus.",
  },
  {
    n: "06",
    title: "Answer Writing Guidance",
    desc: "Frameworks, structures and evaluated practice for Mains — the single biggest differentiator.",
  },
];

// YouTube testimonials — direct from NavSankalpIAS channel (via the poster QR form)
export const YOUTUBE_TESTIMONIALS = [
  { id: "4bd6cKPCfs0", label: "Student Testimony · Vol. 1" },
  { id: "WwcMZ9bvsik", label: "Student Testimony · Vol. 2" },
  { id: "DBmZVYT4B2Q", label: "Student Testimony · Vol. 3" },
  { id: "HgDteh1Tm4w", label: "Student Testimony · Vol. 4" },
  { id: "EWsk03jxMPM", label: "Student Testimony · Vol. 5" },
];

// Handwritten teaching illustrations (personalised strategy, follow-up every 15 days)
export const TEACHING_ILLUSTRATIONS = [
  {
    src: "/showcase/illustration-1.jpg",
    title: "Daily Schedule & 95-Day Plan",
    caption:
      "A student's actual timetable — hour-by-hour study slots, monthly targets, MCQ practice grid, essay Sundays.",
  },
  {
    src: "/showcase/illustration-2.jpg",
    title: "Personalised Roadmap",
    caption:
      "Custom-drawn strategy notes prepared for a working aspirant — sequence of subjects, revision cycles, test integration.",
  },
  {
    src: "/showcase/illustration-3.jpg",
    title: "Follow-up & Adjustment",
    caption:
      "Every fifteen days, the plan is reviewed and re-tuned to what's working — this is what personalised mentorship actually means.",
  },
];
